import React,{useState} from "react";
import { Modal, Form, Input, Button, message, Row, Col,Popconfirm } from "antd";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import {
  validateName,
  validateAddress,
  validateCellPhone,
  validateIdentificationNumber,
} from "./validations";

export const Create = ({ isModalOpen, setIsModalOpen, update }) => {
  const [form] = Form.useForm();

  const db = getFirestore();

  // handle pop confirm
  const [confirmVisible,setConfirmVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleSubmit = async (values) => {
    await addDoc(collection(db, "providers"), {
      ...values,
      status: true,
    })
      .then(() => {
        form.resetFields();
        update();
        message.success(`Proveedor ${values.name} fue creado`);
        setIsModalOpen(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleConfirm = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      form.submit();
      setConfirmVisible(false);
      setConfirmLoading(false);
    },2000);
  };

  const handleCancel = () => {
    setConfirmVisible(false);
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      title="Informacion de proveedor"
    >
      <Form
        name="createProvider"
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        autoComplete="off"
        requiredMark
      >
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item
              name="name"
              label="Nombre"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar proveedor",
                },
                {
                  validation: validateName,
                },
              ]}
              hasFeedback
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item
              name="identifier"
              label="RUC o DNI"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar un numero de identificion",
                },
                {
                  validation: validateIdentificationNumber,
                },
              ]}
              hasFeedback
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item
              name="adress"
              label="Dirección"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar una direccion",
                },
                {
                  validation: validateAddress,
                },
              ]}
              hasFeedback
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12}>
            <Form.Item
              name="phone"
              label="Número de contacto"
              rules={[
                {
                  required: true,
                  message: "Debe ingresar un numero de contacto",
                },
                {
                  validation: validateCellPhone,
                },
              ]}
              hasFeedback
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item className="button-form footer-btn-modal create-form-btns">
          <Button onClick={() => setIsModalOpen(false)} size="large">
            Cancelar
          </Button>
          <Popconfirm
            title="Crear proveedor ?"
            open={confirmVisible}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            okButtonProps={{
              loading:confirmLoading,
            }}
            okText="Si"
            cancelText="No"
          >
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              className="button-right"
              onClick={() => setConfirmVisible(true)}
            >
              Crear
            </Button>
          </Popconfirm>
        </Form.Item>
      </Form>
    </Modal>
  );
};
